import React from 'react';
import clsx from 'clsx';
import { Box } from '../Box';
export function DatePickerMenu(props) {
    const { children, className, ...rest } = props;
    return (React.createElement(Box.Restricted, { ...rest, className: clsx('mollie-ui-date-picker-menu', className) }, children));
}
DatePickerMenu.displayName = 'DatePicker.Menu';
//# sourceMappingURL=DatePickerMenu.js.map